import MainContainer from 'components/generic/MainContainer'
import OuterContainer from 'components/generic/OuterContainer'
import React, { useMemo, useState } from 'react'
import AccountSideNav from './AccountSideNav'
import styles from './myAccount.module.scss'
import 'react-toastify/dist/ReactToastify.css'
import { MyAccountSections, SECTION_COMPONENTS } from 'constants/my-account'
import { getQueryParam } from 'utils'
import withOnlyAllowLoggedIn from 'components/generic/hoc/withOnlyAllowLoggedIn'
import AccountProfileStrength from './AccountProfileStrength'

interface Props {
  enableSelfSubmission?: boolean
}

const MyAccount = React.memo(({ enableSelfSubmission }: Props) => {
  const section = useMemo(() => getQueryParam('section'), [])
  const [activeSection, setActiveSection] = useState(
    SECTION_COMPONENTS[section] ? section : MyAccountSections.MY_DETAILS
  )
  let Component = SECTION_COMPONENTS[activeSection].component

  return (
    <OuterContainer>
      <MainContainer hasBorder={true} className={styles.myAccount}>
        <h1>My account</h1>
        <div className={styles.content}>
          <div className={styles.sideNavContainer}>
            <AccountSideNav
              activeTab={SECTION_COMPONENTS[activeSection].id}
              onTabClick={setActiveSection}
            />
            <AccountProfileStrength
              enableSelfSubmission={enableSelfSubmission}
              setActiveSection={setActiveSection}
            />
          </div>
          <Component />
        </div>
      </MainContainer>
    </OuterContainer>
  )
})

export default withOnlyAllowLoggedIn(MyAccount)
